import Init from '../Init/Init';
import { getFormattedDatetime, responseFormat } from '../Util/Util';
import api from './API';

const pathList = {
    list: '/app-repo/',
}

export const appRepoList = async () => {
    try {
        const request = {};
        const response = await api.getCall(pathList.list, null, request);

        return response;
    } catch(e) {
        return responseFormat(-1, 'Failed to get app urls!', []);
    }
}